import { render, staticRenderFns } from "./LearnAndEarn.vue?vue&type=template&id=6d5faa5b"
import script from "./LearnAndEarn.vue?vue&type=script&lang=js"
export * from "./LearnAndEarn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports